import agencyDashboardAPI from '@/utils/api/agencyDashboard';
import { genericError, inviteSuccess } from '@/utils/alerts.service';

export const sendInvitations = {
  namespaced: true,
  actions: {
    sendInvitation({ dispatch }, data) {
      return agencyDashboardAPI
        .sendInvitation(data)
        .then(() => {
          dispatch('showUserMessage', { ...inviteSuccess }, { root: true });
          return true;
        })
        .catch(() => {
          dispatch('showUserMessage', { ...genericError }, { root: true });
          return false;
        });
    },
  },
};
